var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.menu == true
    ? _c("div", { staticClass: "md-toolbar-section-end" }, [
        _c(
          "a",
          {
            staticClass: "main_menu_header_phone desktop-only",
            attrs: {
              href: "tel:" + _vm.getPhoneNumberWithoutSpaces,
              rel: "noopener"
            }
          },
          [
            _c("img", {
              staticClass: "footer_phone",
              attrs: { src: "/imgs/phone-green.svg" }
            }),
            _vm._v(" " + _vm._s(_vm.getPhoneNumber) + "\n    ")
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "main_menu_header_phone mobile-only",
            attrs: {
              href: "tel:" + _vm.getPhoneNumberWithoutSpaces,
              rel: "noopener"
            }
          },
          [_vm._v(_vm._s(_vm.getPhoneNumber))]
        )
      ])
    : this.menu == false
    ? _c("div", [
        _c(
          "a",
          {
            attrs: {
              href: "tel:" + _vm.getPhoneNumberWithoutSpaces,
              rel: "noopener"
            }
          },
          [
            _c("img", {
              staticClass: "footer_phone",
              attrs: { src: "/imgs/phone.svg" }
            }),
            _vm._v("\n            " + _vm._s(_vm.getPhoneNumber) + "\n    ")
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64957cdb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64957cdb","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/GetCountryDomain.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-64957cdb","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/GetCountryDomain.vue
// module chunks = 1 2 3